import { Form, FormTheme } from '@kanda-libs/ks-component-ts';
import { Loader } from '@kanda-libs/ks-design-library';
import EnquiryContactDetailsFormFields from 'pages/Enquiry/ContactDetails/ContactFields';
import { CLASS_NAMES } from './constants';
import useEnquiryQuoteContactDetailsForm from './useEnquiryQuoteContactDetailsForm';

const EnquiryQuoteContactDetails: React.FunctionComponent = function () {
  const { form, onSubmit, isSubmitting } = useEnquiryQuoteContactDetailsForm();
  return (
    <Form id="enquiry-quote-contact-details" form={form} onSubmit={onSubmit}>
      <FormTheme variant="streamline">
        <div className="flex flex-col mt-2">
          <h1 className={CLASS_NAMES.header}>Provide contact information</h1>
          <h3 className={CLASS_NAMES.subheader}>
            Ideal4Finance need some basic contact information so that they know
            who they are addressing, and so that they can send you a secure
            finance application link
          </h3>
          <EnquiryContactDetailsFormFields />
          <Loader isLoading={isSubmitting} />
        </div>
      </FormTheme>
    </Form>
  );
};

export default EnquiryQuoteContactDetails;
